/* eslint-disable */  // Remove this when the issue is figured out
const numbro = require('numbro');
const languages = require('numbro/dist/languages.min');
Object.values(languages).forEach(function(l) {
	numbro.registerLanguage(l);
});

const DEFAULT_CURRENCY_CODE = 'USD';
const DEFAULT_LOCALE = 'en-US';

const LOCALE_CURRENCY_CODES = {
	'en-US': {
		code: 'USD',
		currencyFormat: '$0,0.00',
		currencyCondensedFormat: '$0,0',
	},
	'fr-CA': {
		code: 'CAD',
		currencyFormat: '$ 0,0.00',
		currencyCondensedFormat: '$ 0,0',
	},
};

function NumberFormat(lang) {
	const language = lang ? lang : DEFAULT_LOCALE;
	numbro.setLanguage(language);
}

/**
 * Display currency with decimal places always shown.
 * @param {number} number
 * @param {string} currencyCode
 */
NumberFormat.prototype.currency = function currency(number, currencyCode) {
	const num = Number(number) || 0;
	const lang = numbro.language();

	const localeCurrencyData = LOCALE_CURRENCY_CODES[lang];
	const finalCurrencyFormat = localeCurrencyData.currencyFormat;

	const formattedNumber = numbro(num).formatCurrency(finalCurrencyFormat);

	if (currencyCode && currencyCode !== DEFAULT_CURRENCY_CODE) {
		return (formattedNumber + ' ' + currencyCode);
	}

	return formattedNumber;
};

/**
 * Display currency without decimal places. Rounds to nearest integer.
 * @param {number} number
 * @param {string} currencyCode
 */
NumberFormat.prototype.currencyCondensed = function currencyCondensed(number, currencyCode) {
	const num = Math.round(number) || 0;
	const lang = numbro.language();

	const localeCurrencyCondensedData = LOCALE_CURRENCY_CODES[lang];
	const finalCurrencyCondensedFormat = localeCurrencyCondensedData.currencyCondensedFormat;
	const formattedNumber = numbro(num).formatCurrency(finalCurrencyCondensedFormat);

	return currencyCode
		? (formattedNumber + ' ' + currencyCode)
		: formattedNumber;
};

/**
 * Display a percentage.
 * @param {number} number
 * @param {boolean} isFloat
 * @param {number} decimals
 */
NumberFormat.prototype.percentage = function percentage(number, isFloat, decimals) {
	var bro;
	const num = number || 0;

	if (isFloat) {
		bro = numbro(num);
	} else {
		bro = numbro(num / 100);
	}

	const noOfDecimals = decimals || 2;
	const decFormat = '0'.repeat(noOfDecimals);
	const formatStr = '0[.][' + decFormat + '}]%';
	return bro.format(formatStr);
};

NumberFormat.prototype.stringToFloat = function stringToFloat(str) {
	if (!str.replace) { return str; }
	return parseFloat(str.replace(/[^0-9.-]+/g, ''));
};

NumberFormat.prototype.stringToInt = function stringToInt(str) {
	if (!str.replace) { return str; }
	return parseInt(str.replace(/[^0-9-]+/g, ''), 10);
};

module.exports = function NumberFormatFactory(lang) {
	return new NumberFormat(lang);
};
